import { useCallback, useEffect, useRef } from 'react';
export const useStableCallback = (fn) => {
    const fnRef = useRef(fn);
    useEffect(() => {
        fnRef.current = fn;
    });
    return useCallback((...args) => fnRef.current(...args), []);
};
//# sourceMappingURL=useStableCallback.js.map